module.exports = __webpack_public_path__ + "img/cell-funds-logo.d377c283.png";